import { useEffect } from "react";

import { isInternalWaitEvent } from "@app/component/flows/base/MmcTour/assert";
import waitForElement from "@app/component/flows/utils/waitForElement";
import { AnalyticsService } from "@app/util/analytic/AnalyticsService";

import { InternalEventWait, TourStep } from "../../types/TourDescriptor";

const useWaitForUserActions = (step?: TourStep, onGoNext?: () => void) => {
  useEffect(() => {
    if (!step || !step.waitForEvent || !onGoNext) {
      return;
    }

    if (isInternalWaitEvent(step.waitForEvent)) {
      const listener = (event: string, properties: any) => {
        const wait = step.waitForEvent as InternalEventWait;
        if (wait?.properties) {
          const expectedProps = wait.properties;
          if (!Object.keys(expectedProps).every((key) => expectedProps[key] === properties[key])) {
            return;
          }
        }
        onGoNext();
      };
      // subscribe to internal events
      const event = step.waitForEvent.selector;
      AnalyticsService.addEventListener(event, listener);
      return () => {
        AnalyticsService.removeEventListener(event, listener);
      };
    }

    const listener = () => {
      // console.error("!!! listener called", step);
      onGoNext();
    };

    // const element = document.querySelector<HTMLElement>(step.waitForEvent.selector);
    // console.log("!!! waiting for", step.waitForEvent, "on", element);

    // No timeout: the target may appear only after a slow user action (e.g. drawing a lasso),
    // and the cleanup below stops the polling when the step changes.
    const intervalId = waitForElement(
      step.waitForEvent.selector,
      () => {
        // console.log("!!! element found on page, subscribing to events");
        const element = document.querySelector<HTMLElement>(step.waitForEvent!.selector as string);
        element?.addEventListener(step.waitForEvent!.eventType, listener);
      },
      { timeout: 0 }
    );

    return () => {
      // console.log("!!! removed event listener");
      if (intervalId) {
        clearInterval(intervalId);
      }
      const element = document.querySelector<HTMLElement>(step.waitForEvent!.selector as string);
      element?.removeEventListener(step.waitForEvent!.eventType, listener);
    };
  }, [onGoNext, step]);
};

export default useWaitForUserActions;
